/** Parse version route param (guards against accidental URL paste). */
export function parseConnectorVersionParam(versionNumber) {
  if (versionNumber === undefined || versionNumber === null) {
    return NaN;
  }

  const match = String(versionNumber).match(/^(\d+)/);

  return match ? Number(match[1]) : NaN;
}

/** URL-safe connector key: lowercase, hyphens/underscores, no spaces. */
export function normalizeConnectorKey(key) {
  return key
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^-a-z0-9_]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function isValidConnectorKey(key) {
  return /^[a-z0-9][-a-z0-9_]*$/.test(key);
}
